import styled from '@emotion/styled'

export const StyleBg = styled.span<any>`
  background: ${(props: any) => props.theme.colors[props?.bg || 'primary50']};
  color: ${(props: any) => props.theme.colors[props?.tc || 'primary']};
  font-size: 12px;
  padding: 5px 8px;
  border-radius: 4px;
  display: block;
  text-align: center;
  width: max-content;

  @media (max-width: 768px) {
    font-size: 10px;
  }

  @media (max-width: 480px) {
    font-size: 9px;
  }
`
